var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 h-100" },
    [
      this.currentJob.state === "draft" ? _c("welcome") : _vm._e(),
      _vm._v(" "),
      _c(_vm.dynamicComponent, { tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }